import Vue from "vue";
import Vuex from "vuex";
import VueCookies from "vue-cookies";
import tab from './tab.js'
Vue.use(VueCookies);
import createPersistedState from "vuex-persistedstate";
//使用vuex
Vue.use(Vuex);
//创建Vuex实例
const store = new Vuex.Store({
  modules: {
    tab
  },
  state: {
    cookie: "", //登陆SSOID
    userName: "", //用户云号
    isLogin: "",
    onceRequest: false,
    SSOID: "",
    areaCodeTop: VueCookies.get("areaLayer"), //SSP 联动
    userinfo: VueCookies.get("userinfo"), //用户信息 要加.user
    areaLayer: VueCookies.get("areaLayer"), //地区编码
    areaName: VueCookies.get("areaName"), //地区名称
    kqLayer: VueCookies.get("kqLayer"), //获取地区接口返回的请求体
    areapath: VueCookies.get("areapath"), //获取地区接口返回的请求体
    domainUri: VueCookies.get("domainUri"),
    adCode: [], //code码
    addRoutes: [], //路由
    menus: [], //侧边栏
  },
  mutations: {
    REQ_AREACODEtop(state, areaCodeTop) {
      state.areaCodeTop = areaCodeTop;
    },
    loginOnce(state, areaCodeTop) {
      state.onceRequest = areaCodeTop;
    },
  },
  getters: {},
  plugins: [createPersistedState()], //加上这个就可以了
});

export default store;
// export default
